import React from "react";
import { IonCol, IonToolbar, IonChip, IonLabel, IonIcon } from "@ionic/react";
import { closeCircle } from "ionicons/icons";
import { filterList } from "../../aerotow/AeroTowList";
import { subtractTimeArr, timeArrayCorrection, timeArrToString } from "../../common/TimeUtils";

/**
 * Component for displaying filter chips and calculated times
 */
export const FilterChips = ({
  flyDay,
  filterPilotSelector,
  filterGliderSelector,
  filterTowingPlaneSelector,
  filterTowingPilotSelector,
  onFilterPilotRemove,
  onFilterGliderRemove,
  onFilterTowingPlaneRemove,
  onFilterTowingPilotRemove
}) => {
  if (!flyDay) return null;

  const filteredList = filterList(
    flyDay.tows,
    filterPilotSelector,
    filterGliderSelector,
    filterTowingPlaneSelector,
    filterTowingPilotSelector
  );

  let gliderTimeArr = [0, 0];
  let towingTimeArr = [0, 0];

  filteredList.forEach(tow => {
    if (tow.start && tow.gliderLanding) {
      const time = subtractTimeArr(tow.gliderLanding, tow.start);
      gliderTimeArr[0] += time[0];
      gliderTimeArr[1] += time[1];
      gliderTimeArr = timeArrayCorrection(gliderTimeArr);
    }
    if (tow.start && tow.towingPlaneLanding) {
      const time = subtractTimeArr(tow.towingPlaneLanding, tow.start);
      towingTimeArr[0] += time[0];
      towingTimeArr[1] += time[1];
      towingTimeArr = timeArrayCorrection(towingTimeArr);
    }
  });

  const timeDisplay = (timeArr) =>
    flyDay.closed
      ? `${filteredList.length}x - ${timeArrToString(timeArr)}`
      : `${filteredList.length}x`;

  return (
    <IonCol size="8">
      <IonToolbar>
        {filterPilotSelector && (
          <IonChip onClick={onFilterPilotRemove}>
            <IonLabel>
              {filterPilotSelector.name} {filterPilotSelector.surname}
            </IonLabel>
            <IonIcon icon={closeCircle} />
          </IonChip>
        )}
        {filterGliderSelector && (
          <IonChip onClick={onFilterGliderRemove}>
            <IonLabel>
              {filterGliderSelector.name} ({filterGliderSelector.registration})
            </IonLabel>
            <IonIcon icon={closeCircle} />
          </IonChip>
        )}
        {(filterPilotSelector || filterGliderSelector) && (
          <IonLabel>{timeDisplay(gliderTimeArr)}</IonLabel>
        )}
        {filterTowingPlaneSelector && (
          <>
            <IonChip onClick={onFilterTowingPlaneRemove}>
              <IonLabel>
                {filterTowingPlaneSelector.name} ({filterTowingPlaneSelector.registration})
              </IonLabel>
              <IonIcon icon={closeCircle} />
            </IonChip>
            <IonLabel>{timeDisplay(towingTimeArr)}</IonLabel>
          </>
        )}
        {filterTowingPilotSelector && (
          <>
            <IonChip onClick={onFilterTowingPilotRemove}>
              <IonLabel>
                {filterTowingPilotSelector.surname} {filterTowingPilotSelector.name}
              </IonLabel>
              <IonIcon icon={closeCircle} />
            </IonChip>
            <IonLabel>{timeDisplay(towingTimeArr)}</IonLabel>
          </>
        )}
      </IonToolbar>
    </IonCol>
  );
};

